import { gql } from '@apollo/client';

export const GET_DEALER = gql`
  query dealerById($dealerId: String!) {
    dealerById(dealerId: $dealerId) {
      name
      displayName
      kvpsId
      address
      city
      zipCode
      region
      phone
      email
      openingHours {
        departments {
          departmentName
          departmentOpeningHoursNote
          id
          openingHours {
            id
            open
            timeRanges {
              closeTime
              openTime
            }
          }
        }
        openingHoursNote
      }
    }
  }
`;
